export const environment = {
    env: 'development',
    apiAuthUrl: 'https://zbe.cat:8001/zbe',
    apiPublicUrl: 'https://zbe.cat:8002/zbe/exceptions',
    apiPrivateUrl: 'https://zbe.cat:8003/zbe/exceptions',
    apiPrivate2Url: 'https://zbe.cat:8004/zbe/exceptions',
    gisURL: 'https://zbe.cat:8443/geoserver/osm/wms?',
    wordpressURL: 'https://wordpress.zbe.cat/wp-json/wp/v2/',
    redirectFront: 'https_zbe-aluvisa.web.app/ca/login-redirect',
    identidadURL: 'https://valid.aoc.cat/o/oauth2/auth',
};